import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';
import { Constants } from '../common/constants';

@Directive({
    selector: '[validateDateOfBirth]',
    providers: [{ provide: NG_VALIDATORS, useExisting: DateOfBirthDirective, multi: true }]
})
export class DateOfBirthDirective implements Validator {
    @Input('validateDateOfBirth') dateOfBirth: any[] = [];

    validate(formGroup: FormGroup): ValidationErrors {
        return ValidateDateOfBirth(this.dateOfBirth[0], this.dateOfBirth[1], this.dateOfBirth[2], this.dateOfBirth[3], this.dateOfBirth[4], this.dateOfBirth[5], this.dateOfBirth[6])(formGroup);
    }
}

function ValidateDateOfBirth(dateOfBirthDay: string, dateOfBirthMonth: string, dateOfBirthYear: string, serverDate: string, isAfricanCountry: number, ageFactorObject: any, visaClass: string): any {
    return (formGroup: FormGroup) => {
        const formGroupDateOfBirthDayObject = formGroup.controls[dateOfBirthDay];
        const formGroupDateOfBirthMonthObject = formGroup.controls[dateOfBirthMonth];
        const formGroupDateOfBirthYearObject = formGroup.controls[dateOfBirthYear];
        // const formGroupVisaClassObject = formGroup.controls[visaClass];


        if (!formGroupDateOfBirthDayObject || !formGroupDateOfBirthMonthObject || !formGroupDateOfBirthYearObject) {
            return null;
        }

        const constants = new Constants();
        if (isValidValue(formGroupDateOfBirthDayObject.value) === false || isValidValue(formGroupDateOfBirthMonthObject.value) === false || isValidValue(formGroupDateOfBirthYearObject.value) === false) {
            return null;
        }

        const givenDateOfBirthDay = formGroupDateOfBirthDayObject.value;
        const givenDateOfBirthMonth = formGroupDateOfBirthMonthObject.value;
        const givenDateOfBirthYear = formGroupDateOfBirthYearObject.value;

        const requiredDateOfBirthValue = givenDateOfBirthMonth + '/' + givenDateOfBirthDay + '/' + givenDateOfBirthYear;
        const dateOfBirthValue = new Date(requiredDateOfBirthValue);
        dateOfBirthValue.setFullYear(givenDateOfBirthYear); // This is used to set the year bcoz 0000 change to 2000 if not set this

        if (isNaN(dateOfBirthValue.getTime()) === true) {
            formGroupDateOfBirthDayObject.setErrors({ hasError: true, errorMessage: 'Date of Birth should be valid date!' });
            return;
        }

        const objectDateDay = dateOfBirthValue.getDate();
        const objectDateMonth = (dateOfBirthValue.getMonth() + 1);

        if (Number(givenDateOfBirthDay) !== objectDateDay || Number(givenDateOfBirthMonth) !== objectDateMonth) {
            formGroupDateOfBirthDayObject.setErrors({ hasError: true, errorMessage: 'Date of Birth should be valid date!' });
            return;
        }

        const serverDateValueArr = serverDate.split("/");
        const requiredServerDateValue = serverDateValueArr[1] + "/" + serverDateValueArr[0] + "/" + serverDateValueArr[2]
        const todayDate = new Date(requiredServerDateValue);

        if (dateOfBirthValue.getTime() > todayDate.getTime()) {
            formGroupDateOfBirthDayObject.setErrors({ hasError: true, errorMessage: 'Date of Birth can not be future date!' });
            return;
        }

        const minimumDateOfBirthValue = givenDateOfBirthMonth + '/' + givenDateOfBirthDay + '/' + constants.MIN_DATE_OF_BIRTH_YEAR;
        const minimumDateOfBirthObject = new Date(minimumDateOfBirthValue);

        if (dateOfBirthValue.getTime() < minimumDateOfBirthObject.getTime()) {
            formGroupDateOfBirthDayObject.setErrors({ hasError: true, errorMessage: 'Year of Birth should be after ' + constants.MIN_DATE_OF_BIRTH_YEAR + '!' });
            return;
        }

        formGroupDateOfBirthDayObject.setErrors(null);

        //TODO THIS IS ADDED ON THE REQUEST OF MANOJ SIR
        // if (isAfricanCountry === constants.TRUE) {
        //     formGroupDateOfBirthDayObject.setErrors(null);
        //     return null;
        // }


        const age = fetchAge(dateOfBirthValue, todayDate);

        const minorVisaClasses = [
            constants.F3B,
            constants.F5A,
            constants.F6A,
            constants.F7F,
            constants.F7I,
            constants.F9B
        ];

        const isMinorVisa = minorVisaClasses.includes(visaClass);
        const isAfrican = isAfricanCountry === constants.TRUE;

        if (isAfricanCountry === constants.TRUE) {
            if (!isMinorVisa && age < 18) {
                formGroupDateOfBirthDayObject.setErrors({
                    hasError: true,
                    errorMessage: "Applicant must be at least 18 years old.",
                });
                return;
            }

        }
        else if (isAfricanCountry === constants.FALSE && age < 18) {
            formGroupDateOfBirthDayObject.setErrors({ hasError: true, errorMessage: "Age of the applicant must be 18 years" });
            return;
        }


        // if (isAfricanCountry === constants.FALSE && age < 18) {
        //     formGroupDateOfBirthDayObject.setErrors({ hasError: true, errorMessage: "Age of the applicant must be 18 years" });
        //     return;
        // }

        if (!minorVisaClasses.includes(visaClass) && ageFactorObject.isMinAgeRestricted === constants.TRUE && age < ageFactorObject.minAge) {
            formGroupDateOfBirthDayObject.setErrors({ hasError: true, errorMessage: "Minimum age of the applicant should be " + ageFactorObject.minAge + " years" });
            return;
        }

        if (ageFactorObject.isMaxAgeRestricted === constants.TRUE && age >= ageFactorObject.maxAge) {
            formGroupDateOfBirthDayObject.setErrors({ hasError: true, errorMessage: "Maximum age of the applicant can be " + ageFactorObject.maxAge + " years" });
            return;
        }

        formGroupDateOfBirthDayObject.setErrors(null);

        return null;
    };
}

function isValidValue(givenValue: any): boolean {
    if (givenValue === undefined || givenValue === null || givenValue === '') {
        return false;
    }
    return true;
}

function fetchAge(dateOfBirthValue: Date, todayDate: Date): number {
    let age = todayDate.getFullYear() - dateOfBirthValue.getFullYear();
    const month = todayDate.getMonth() - dateOfBirthValue.getMonth();
    if (month < 0 || (month === 0 && todayDate.getDate() < dateOfBirthValue.getDate())) {
        age--;
    }
    return age;
}
